export const FORMAT_INVALIDE = "FORMAT_INVALIDE";
export const UTILISATEUR_EXISTE_DEJA = "UTILISATEUR_EXISTE_DEJA";
export const COMBINAISON_UTILISATEUR_MOTDEPASSE_INCORRECTE =
  "COMBINAISON_UTILISATEUR_MOTDEPASSE_INCORRECTE";
